export const TIPO_NUMBER = 0
export const TIPO_RADIOBUTTOM = 1
export const TIPO_CHECKBOX = 2
export const TIPO_PORCENTAGEM = 3
export const TIPO_MONEY = 4
export const TIPO_RESULTADO = 5
export const TIPO_FLOAT2 = 6
export const TIPO_PORCENTAGEM_LIVRE = 7
export const TIPO_FLOAT_LIVRE = 8

export const CRESCIMENTO_TERMINACAO = 'crescimento_terminacao'
export const VACA = 'vaca'
export const BEZERRO = 'bezerro'
export const ID_LEITE_VACA = '0-0|0|0'
export const ID_UREIA = '42-52|0|600'
export const ZEBUINO = 'zebuino'
export const CRUZADO_CORTE = 'cruzado_corte'
export const CRUZADO_LEITE = 'cruzado_leite'
export const CONFINAMENTO = 'confinamento'
export const PASTO = 'pasto'
export const MACHO = 'macho'
export const MACHO_CASTRADO = 'macho_castrado'
export const FEMEA = 'femea'
export const NAO_GESTANTE = 'nao_gestante'
export const LACTANTE = 'lactante'
export const GESTANTE = 'gestante'
export const GESTANTE_LACTANTE = 'gestante_lactante'
export const PRIMIPARAS = "primiparas"
export const MULTIPARAS = "multiparas"

export const MIN_PESO_MACHO = 150
export const MIN_PESO_FEMEA = 300
export const MIN_PESO_BEZERRO = 30

export const MAX_PESO_MACHO = 1200
export const MAX_PESO_FEMEA = 900
export const MAX_PESO_BEZERRO = 350

export const MAX_GMD = 2.5

export const FONTES_COMUNS = [
  '45-52|0|600',
  '94-52|0|600',
  '169-52|0|600',
  '8-52|0|600',
  '2056-52|0|600',
  '151-52|0|600',
  '2055-52|0|600',
  '1295-52|0|600',
  '2057-52|0|600',
  '344-52|0|600',
  '848-52|0|600',
  '2058-52|0|600'
]

export const SUBPRODUTOS_VOLUMOSOS = [
  '1341-52|0|600',
  '304-52|0|600',
  '1022-52|0|600',
  '163-52|0|600',
  '876-52|0|600',
  '1342-52|0|600'
]

export const EMPRESA_GESTOR = 0
export const EMPRESA_GERENTE_REGIONAL = 1
export const EMPRESA_TECNICO_VENDA = 2
export const EMPRESA_PRODUTOR_VINCULADO = 3
export const EMPRESA_TIPOS = [
  'empresa_gestor',
  'empresa_gerente_regional',
  'empresa_tecnico_venda',
  'empresa_produtor_vinculado'
]

// tipos de permissao dos modulos
export const AREA_EMPRESA = 'AREA_EMPRESA'
export const FUNCAO_PREMIUM = 'FUNCAO_PREMIUM'
export const FUNCAO_ADM = 'FUNCAO_ADM'
export const FUNCAO_GESTOR = 'FUNCAO_GESTOR'
export const FUNCAO_CONSULTOR = 'FUNCAO_CONSULTOR'
export const VINCULAR_COLABORADOR = 'VINCULAR_COLABORADOR'
export const EXPORTAR_PDF = 'EXPORTAR_PDF'
export const EXPORTAR_PDF_COMPLETO = 'EXPORTAR_PDF_COMPLETO'
export const EDITAR_EXIGENCIA = 'EDITAR_EXIGENCIA'
export const PROPORCAO_VC = 'PROPORCAO_VC'
export const EDITAR_ALIMENTO_CQBAL = 'EDITAR_ALIMENTO_CQBAL'
export const SALVAR_DIETA = 'SALVAR_DIETA'
export const SALVAR_PREDICAO = 'SALVAR_PREDICAO'
export const ATIVAR_DIETA = 'ATIVAR_DIETA'
export const CRIAR_SUPLEMENTO = 'CRIAR_SUPLIMENTO'
export const REFINAR_DIETA = 'REFINAR_DIETA'
export const REFINAR_PREDICAO = 'REFINAR_PREDICAO'
export const RELATORIO_FINANCEIRO_COMPLETO = 'RELATORIO_FINANCEIRO_COMPLETO'
export const ENVIAR_ALIMENTO = 'ENVIAR_ALIMENTO'
export const ENVIAR_ALIMENTO_EMPRESA = 'ENVIAR_ALIMENTO_EMPRESA'
export const ENVIAR_ALIMENTO_ADAPTADO = 'ENVIAR_ALIMENTO_ADAPTADO'
export const COMPARTILHAR_DIETA = 'COMPARTILHAR_DIETA'
export const COMPATIBILIZAR_PREDICAO = 'COMPATIBILIZAR_PREDICAO'
export const COMPARTILHAR_PREDICAO = 'COMPARTILHAR_PREDICAO'
export const COMPARTILHAR_COM_TODAS_PERMISSOES = 'COMPARTILHAR_COM_TODAS_PERMISSOES'
export const GRAFICOS_DASHBOARD = 'GRAFICOS_DASHBOARD'
export const GRAFICOS_FORMULACAO = 'GRAFICOS_FORMULACAO'
export const REOTIMIZAR_DIETA = 'REOTIMIZAR_DIETA'
export const LISTAR_ALIMENTOS_USUARIO = 'LISTAR_ALIMENTOS_USUARIO'
export const DIETAS_ATIVAS_ILIMITADAS = 'DIETAS_ATIVAS_ILIMITADAS'
export const ESCONDE_BOTAO_EDITAR_EXIGENCIAS = 'ESCONDE_BOTAO_EDITAR_EXIGENCIAS'
export const ESCONDE_BOTAO_COMPATIBILIZAR = 'ESCONDE_BOTAO_COMPATIBILIZAR'
export const ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO = 'ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO'
export const ANUNCIO = 'ANUNCIO'
export const CALCULAR_RACAO = 'CALCULAR_RACAO'
export const FORMULAR_SUPLEMENTO = 'FORMULAR_SUPLEMENTO'

export const PERMITE_ACESSO_GRATUITO = 'PERMITE_ACESSO_GRATUITO'

export const EXIBIR_EXIGENCIAS = 'EXIBIR_EXIGENCIAS'
export const EXIBIR_RESUMO_DIETA = 'EXIBIR_RESUMO_DIETA'
export const AVISO_GRATUITO = 'AVISO_GRATUITO'

export const PERMITE_CHECK_MINERAIS_COMUNS = 'PERMITE_CHECK_MINERAIS_COMUNS'
export const EXIBIR_TABELA_REFERENCIA_BEZERROS = 'EXIBIR_TABELA_REFERENCIA_BEZERROS'

export const PERMITE_SELECIONAR_PADROES_EXIGENCIAS = 'PERMITE_SELECIONAR_PADROES_EXIGENCIAS'
export const EXIBIR_TABELA_RESUMIDA_COMPLETA = 'EXIBIR_TABELA_RESUMIDA_COMPLETA'

export const DADOS_ANIMAL_CARD = 'DADOS_ANIMAL_CARD'
export const SUGESTAO_ALIMENTOS = 'SUGESTAO_ALIMENTOS'

export const COMPARAR_DIETAS = 'COMPARAR_DIETAS'
export const EXIBE_SUPLEMENTOS_CARD = 'EXIBE_SUPLEMENTOS_CARD'

export const MOSTRAR_PRECOS_SALVOS = 'MOSTRAR_PRECOS_SALVOS'
export const ESCONDE_CUSTOS_PAGE = 'ESCONDE_CUSTOS_PAGE'

// ---------------------------------------
